<style scoped>
  .mt9{margin-top:9px;}
  .tit {
    color: gray;
    width: 120px;
    padding-right: 10px;
    float: left;
    text-align: right;
  }
</style>

<template>
  <div style="position: relative">
    <Spin fix v-if="loading"></Spin>

    <Row class='mt9'>
      <Col span='6' class='tit'>申领用户：</Col>
      <Col span='18'>
        <span v-if="detail.user">
            <Avatar :src="detail.user.avatarUrl"/>
        &nbsp;
        {{detail.user.userName}}
        </span>
      <span v-else>{{detail.uid}}（未登录用户）</span>
      </Col>
    </Row>

<Row class='mt9'>
  <Col span='6' class='tit'>公司名称：</Col>
  <Col span='18'>{{detail.gsmc}}</Col>
</Row>
<Row class='mt9'>
  <Col span='6' class='tit'>姓名：</Col>
  <Col span='18'>{{detail.xm}}</Col>
</Row>
<Row class='mt9'>
  <Col span='6' class='tit'>职位：</Col>
  <Col span='18'>{{detail.zw}}</Col>
</Row>
<Row class='mt9'>
  <Col span='6' class='tit'>手机：</Col>
  <Col span='18'>{{detail.sj}}</Col>
</Row>
<Row class='mt9'>
  <Col span='6' class='tit'>邮箱：</Col>
  <Col span='18'>{{detail.yx}}</Col>
</Row>
<Row class='mt9'>
  <Col span='6' class='tit'>备注：</Col>
  <Col span='18'>{{detail.bz}}</Col>
</Row>
<Row class='mt9'>
  <Col span='6' class='tit'>申领时间：</Col>
  <Col span='18'>{{detail.ctime}}</Col>
</Row>


    <Divider orientation="left">用户选择课程（若为空则表示用户未选择）</Divider>

    <div v-for="item in detail.select" style="margin-bottom: 10px;">
      <b>{{item.name}}</b><br/>
      {{item.cc}}
    </div>



  </div>
</template>

<script>
  export default {
    props:['id'],
    data(){
      return{
        detail:{},
        loading:false,
      }
    },
    methods:{
      load(){
        this.loading = true;
        let that = this;
        this.$axios.get('/api/youhui/slyouhui/getById?id='+this.id).then(function(rs){
          that.detail = rs.data;
          that.loading = false;
        });
      }
    },
    created(){
      this.load();
    },
    watch:{
      id:{
        handler(newValue, oldValue) {
          this.load();
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/youhui/SlyouhuiDetail.vue